<template>
  <div class="create-one-report-jo" v-loading="isInit">
    <div class="mob-show-create mobile-header-create">
      <strong></strong>

      <div style="display: flex; align-items: center">
        <div style="display: flex; align-items: center; cursor: pointer" @click="dialogObjectTime = true">
          <i class="fas fa-user-friends"></i>

          <span style="margin-left: 4px">
                  <strong
                    :style="{color: form.totalProfPlan  > form.totalProfValue ? '#D32F2F' : '#7CB342'}"
                    style="margin-right: 0">{{ form.totalProfPlan }}</strong>/<strong>{{
              form.totalProfValue || 0
            }}</strong>
                </span>
        </div>

        <div
          v-if="$store.state.project.reportOne && $store.state.project.reportOne.analytics === 'volume' "
          class="progress-circle progress-circle-header-ro"
          :style="{color: '#fff', borderColor: pStatus(form.totalPercent || 0)}">
          {{ formatNumber(form.totalPercent || 0) }}%
        </div>

        <div class="progress-circle progress-circle-header-ro"
             v-if="$store.state.project.reportOne && $store.state.project.reportOne.progressAnalytics === 'progress' "
             :style="{color: '#fff', borderColor: getProfColor(form)}">
          {{ formatNumber(totalProfPercent|| 0) }}%
        </div>

        <div class="dot-auto" @click="calcAuto"></div>
      </div>
    </div>
    <div style="width: 100%" v-if="!isInit">

      <el-form class="desktop-header desktop-show-create">
        <div class="desktop-header-left">
          <h4 style="margin-left: 8px; margin-right: 8px">
            #{{ form.index }}
          </h4>

          <template v-if="$route.params.id && $route.name !== 'onereportsCopy'"
                    style="width: 320px;  display: flex; align-items: center">
            <i style="font-size: 28px; margin-left: 12px" class="el-icon-delete" v-if="!form.approve"
               @click="deleteReport"></i>
            <i style="font-size: 28px; margin-left: 12px" class="el-icon-document-copy"
               @click="copyData.dialogVisible = true"></i>
            <i
              @click="approve"

              class="el-icon-success" style="font-size: 28px; margin-left: 16px; margin-right: 18px"
              v-if="form.approve"></i>

            <i style="font-size: 28px; margin-left: 16px; margin-right: 18px" class="el-icon-circle-check"
               v-else-if="isApprove" @click="approve"></i>
          </template>

          <div style="display: flex">
            <div
              v-if="$store.state.project.reportOne && $store.state.project.reportOne.analytics === 'volume' "
              class="progress-circle progress-circle-header-ro"
              :style="{color: pStatus(form.totalPercent || 0), borderColor: pStatus(form.totalPercent || 0)}">
              {{ formatNumber(form.totalPercent || 0) }}%
            </div>

            <div class="progress-circle progress-circle-header-ro"
                 v-if="$store.state.project.reportOne && $store.state.project.reportOne.progressAnalytics === 'progress' "
                 :style="{color:  getProfColor(form), borderColor: getProfColor(form)}">
              {{ formatNumber(totalProfPercent || 0) }}%
            </div>

            <div style="display: flex; align-items: center; cursor: pointer"
                 @click="dialogObjectTime = true; tmpTime = timeProfGlobal.value">
              <i class="fas fa-user-friends"></i>

              <span style="margin-left: 4px">
                  <strong
                    :style="{color: form.totalProfPlan  > form.totalProfValue ? '#D32F2F' : '#7CB342'}"
                    style="margin-right: 0">{{ form.totalProfPlan }}</strong>/<strong>{{
                  form.totalProfValue || 0
                }}</strong>

                </span>
            </div>
          </div>


          <el-date-picker
            :editable="false"
            format="yyyy-MM-dd"
            v-model="form.datetime"
            :picker-options="pickerOptions"
            @change="changeDate"

            type="date"
            :disabled="form.approve"
            placeholder="Укажите дату"
          >
          </el-date-picker>
        </div>

        <div class="desktop-header-right">
          <strong style="margin-right: 12px; margin-left: 8px">{{ user.name }}</strong>

          <div class="desktop-header-selects">
            <div class="user-select">
              <filter-select
                :disabled="!(user.role === 'admin')"
                placeholder="Исполнитель"
                style="margin-right: 12px"
                hide-label
                :class="{'disable-report': form.approve || form.isWorkOrder}"
                v-model="form.user"
                label="Исполнитель"
                :options="usersOptions"
              />
            </div>
            <filter-select
              hide-label
              placeholder="Смена"
              :class="{'disable-report': form.approve || form.isWorkOrder}"

              @input="calcTotalProfPlan"
              :disabled="this.form.timesheetId"
              v-model="form.turn"
              label="Смена"
              :options="shifts"
            />
          </div>
        </div>
      </el-form>
      <el-form class="reports-create workorder-create" label-position="top">
        <div class="reports-edit-header mob-show-create" v-if="$route.params.id && $route.name !== 'onereportsCopy'">
          <div @click="deleteReport"
               v-if="!form.approve"
               :class="['i-container']"
          >
            <i class="el-icon-delete"></i>
            <span>Удалить</span>
          </div>
          <div
            @click="copyData.dialogVisible = true"
            :class="['i-container']"
            class="i-container"
          >
            <i class="el-icon-document-copy"></i>
            <span>Копировать</span>
          </div>
          <div v-if="isApprove" class="i-container" @click="approve">
            <i class="el-icon-success" style="font-size: 28px; margin-left: 16px; margin-right: 18px"
               v-if="form.approve"></i>

            <i v-else class="el-icon-circle-check" style="font-size: 28px"></i>

            <span>Утвердить отчет</span>
          </div>
          <!--          <div class="i-container" v-clipboard:copy="link" v-clipboard:success="onCopy">-->
          <!--            <i class="fa  fa-link" style="font-size: 20px"></i>-->
          <!--            <span>Скопировать ссылку</span>-->
          <!--          </div>-->
        </div>
        <div class="date-create mob-show-create">
          <div style="display: flex; align-items: center">
            <el-date-picker
              :editable="false"
              format="yyyy-MM-dd"
              v-model="form.datetime"
              :picker-options="pickerOptions"
              style="max-width: 172px; width: 100%"
              type="date"
              :disabled="!isEditable || form.approve"
              placeholder="Укажите дату"
            >
            </el-date-picker>
          </div>


          <h4 style="margin-left: 8px">
            #{{ form.index }}
          </h4>

          <div style="display: flex" class="desktop-show-create">
            <div
              v-if="$store.state.project.reportOne && $store.state.project.reportOne.analytics === 'volume' "
              class="progress-circle"
              :style="{color: pStatus(form.totalPercent || 0), borderColor: pStatus(form.totalPercent || 0), marginLeft: '8px'}">
              {{ formatNumber(form.totalPercent || 0) }}%
            </div>

            <div class="progress-circle"
                 v-if="$store.state.project.reportOne && $store.state.project.reportOne.progressAnalytics === 'progress' "
                 :style="{color:  getProfColor(form), borderColor: getProfColor(form), marginLeft: '8px'}">
              {{ formatNumber(totalProfPercent || 0) }}%
            </div>
          </div>
        </div>

        <div>

        </div>

        <AddJobsWork
          :isEditable="isEditable"
          :user="user"
          :report="form"
          :approve="form.approve"
          ref="addJobsWork"
          :mainForm="form"
          :is_tabel_report="((form.user._data && form.user._data.is_one_report_table) || form.user.is_one_report_table)"
          v-if="isLoad"
          :dirs="dirs"
          :options_works="options_works"
          @update="updateObjects"
          :inputObjects="form.inputObjects"
          :index="calcIndex(form)"
        />

        <div class="main-tech-inputs mob-show-create">
          <template v-if="$store.state.project.available_reports.PROF" class="mob-show-create">
            <div class="tech-name" style="margin-top: 12px">
              <strong style="margin-top: 0">Численность</strong>
            </div>
            <div class="job-inputs">
              <el-input class="input" :placeholder="`${profPlanFact.fact} - Рабочие`" disabled></el-input>
              <el-input class="input" :placeholder="`${profPlanFact.itr} - ИТР`" disabled></el-input>
              <i class="fa fa-chevron-right" @click="worksModal = true"></i>
            </div>
          </template>
          <template v-if="$store.state.project.available_reports.TECH" class="mob-show-create">
            <div class="tech-name" style="margin-top: 12px">
              <strong style="margin-top: 0">Техника</strong>
            </div>
            <div class="job-inputs">
              <el-input class="input" :placeholder="`${techPlanFact.fact} - количество единиц`" disabled></el-input>
              <i class="fa fa-chevron-right" @click="techModal = true"></i>
            </div>
          </template>
        </div>


        <div class="prof-tech-desktop desktop-show-create">
          <div style="max-width: 50%" class="prof-desktop" v-if="$store.state.project.available_reports.PROF">
            <div :class="['line-title', {disabled: form.approve}]" @click="worksModal = true">
              <strong style="margin-top: 0"> Численность</strong>
              <div class="plus-btn">+</div>
            </div>

            <el-table
              :data="profs"
              style="width: 100%">

              <el-table-column
                prop="name"
                label="Наименование">
                <template slot-scope="scope">
                  <span v-if="!scope.row.strong"> {{ scope.row.name }}</span>
                  <strong v-else> {{ scope.row.name }} </strong>
                </template>
              </el-table-column>
              <el-table-column
                label="План"
                prop="value"
                v-if="$store.state.project.reportOne && $store.state.project.reportOne.profAnalytics"
                width="68">
                <template slot-scope="scope">
                  <strong
                    :style="{color: form.totalProfPlan > scope.row.value ? '#D32F2F' : '#7CB342'}"
                    v-if="scope.row.sum"> {{ parseFloat(Number(form.totalProfPlan).toFixed(0)) }}</strong>
                </template>
              </el-table-column>

              <el-table-column
                label="Норм."
                prop="value"
                width="68">
                <template slot-scope="scope">
                  <strong
                    v-if="scope.row.sum"> {{ parseFloat(Number(form.totalProfPlanNorm).toFixed(0)) }}</strong>
                </template>
              </el-table-column>

              <el-table-column
                label="Факт"
                prop="value"
                width="68">
                <template slot-scope="scope">
                  <span v-if="!scope.row.strong"> {{ scope.row.value }}</span>
                  <strong v-else> {{ Number(scope.row.value).toFixed(0) }}</strong>
                </template>
              </el-table-column>
              <el-table-column
                label="Норм."
                prop="value"
                v-if="$store.state.project.reportOne && $store.state.project.reportOne.progressAnalytics === 'progress' "
                width="68">
                <template slot-scope="scope">
                  <strong
                    :style="{color: form.totalProfNorm < scope.row.time? '#D32F2F' : '#7CB342'}"

                    v-if="scope.row.sum"> {{ parseFloat(Number(form.totalProfNorm).toFixed(0)) }}</strong>
                </template>
              </el-table-column>
              <el-table-column
                label="Часы"
                prop="time"
                width="68">
                <template slot-scope="scope">
                  <span v-if="!scope.row.strong"> {{ scope.row.time }}</span>
                  <strong v-else> {{ scope.row.time }} </strong>
                </template>
              </el-table-column>
            </el-table>

            <div v-if="calcFot && role === 'admin' && (calcFot.plan || calcFot.fact)"
                 style="display: flex; align-items: center; margin-top: 12px">
              <strong>ФОТ:</strong>
              <span style="margin-right: 8px">План:   {{ calcFot.plan }} </span>
              <span style="margin-right: 8px">Факт: {{ calcFot.fact }} </span>

              <strong :class="calcFot.fact - calcFot.plan > 0 ? 'red' : 'green'"> +/-
                {{ parseFloat(Number(calcFot.fact - calcFot.plan).toFixed(2)) }}</strong>
            </div>
          </div>
          <div style="max-width: 50%" :class="['tech-desktop']" v-if="$store.state.project.available_reports.TECH">
            <div :class="['line-title', {disabled: form.approve}]" @click="techModal = true">
              <strong style="margin-top: 0">Техника</strong>
              <div class="plus-btn">+</div>
            </div>

            <el-table
              :data="techs"
              style="width: 100%">

              <el-table-column
                prop="name"
                label="Наименование">
                <template slot-scope="scope">
                  <span v-if="!scope.row.strong"> {{ scope.row.name }}</span>
                  <strong v-else> {{ scope.row.name }} </strong>
                </template>
              </el-table-column>
              <el-table-column
                label="Факт"
                prop="value"
                width="60">
                <template slot-scope="scope">
                  <span v-if="!scope.row.strong"> {{ scope.row.value }}</span>
                  <strong v-else> {{ scope.row.value }} </strong>
                </template>
              </el-table-column>
              <el-table-column
                label="Часы"
                prop="time"
                width="60">
                <template slot-scope="scope">
                  <span v-if="!scope.row.strong"> {{ scope.row.time }}</span>
                  <strong v-else> {{ scope.row.time }}</strong>
                </template>
              </el-table-column>
            </el-table>

          </div>
        </div>

        <div v-if="role === 'admin'" class="mob-show-create">
          <filter-select
            :class="{'disable-report': form.approve || form.isWorkOrder}"
            v-model="form.user"
            label="Исполнитель"
            :disabled="!(user.role === 'admin')"
            :options="usersOptions"
          />
        </div>

        <div :class="{'disable-report': form.approve || form.isWorkOrder}" class="mob-show-create">
          <filter-select
            :disabled="this.form.timesheetId"
            v-model="form.turn"
            label="Смена"
            @input="calcTotalProfPlan"
            :options="shifts"
          />
        </div>

        <div class="create-comment" style="flex-direction: row">
          <div class="comment-textarea">
            <el-form-item label="Комментарии" :class="{'disable-report':  form.approve || form.isWorkOrder}">
              <div class="el-textarea">
                <!--                  <vue-tribute :options="{...tributeOptions}">-->
                <textarea class="el-textarea__inner" type="textarea"
                          v-model="form.comment"></textarea>
                <!--                  </vue-tribute>-->
              </div>
            </el-form-item>
          </div>
          <div class="report-file">
            <UploadFile
              flag
              :disabled="this.form.timesheetId || form.approve || form.isWorkOrder"
              :fileListProps="fileList"
              @add-file="addFile"
            />
            <div :key="index" v-for="(file, index) in form.files" class="links-list">
              <a target="_blank" :href="file">Прикрепленный файл #{{ index + 1 }}</a>
              <i class="el-icon-delete" :class="{'disable-report':  form.approve || form.isWorkOrder}"
                 @click="deleteImg(index)"></i>
            </div>
          </div>
        </div>

        <el-dialog :visible.sync="dialogObject">
          <img style="width: 100%;" :src="previewSrc">
        </el-dialog>

        <el-dialog :visible.sync="dialogObject">
          <img style="width: 100%;" :src="previewSrc">
        </el-dialog>

        <div :class="['create-footer']">
          <div style="width: 100%;">
            <div class="create-footer-container" style="display:flex; justify-content: space-between">
              <el-button @click="back">Отмена</el-button>
              <el-button type="primary" @click="save" v-if="!form.approve">Сохранить</el-button>
            </div>
          </div>
        </div>
      </el-form>

      <el-dialog
        width="440px"
        :title="`${(form.user._data && form.user._data.is_one_report_table) || form.user.is_one_report_table ? 'Табель' : 'Отчет по численности'}`"
        :show-close="false"
        :visible.sync="worksModal"
      >
        <AddJobsTabel
          :isEditable="isEditable"
          type="PROF"
          @close="worksModal = false"
          :report="form"
          :user="user"
          ref="addJobsWork"
          :dirs="dirs"
          :mainForm="form"
          v-if="isLoad && worksModal && ((form.user._data && form.user._data.is_one_report_table) || form.user.is_one_report_table)"
          :approve="form.approve"
          :options_works="options_works"
          @update="updateObjectsProf"
          :inputObjects="JSON.parse(JSON.stringify(form.profObjects))"
          :index="calcIndex(form)"
        >
        </AddJobsTabel>
        <AddJobsWorkProf
          :isEditable="isEditable"
          type="PROF"
          @close="worksModal = false"
          :report="form"
          :user="user"
          ref="addJobsWork"
          :dirs="dirs"
          :mainForm="form"
          v-else-if="isLoad && worksModal"
          :approve="form.approve"
          :options_works="options_works"
          @update="updateObjectsProf"
          :inputObjects="JSON.parse(JSON.stringify(form.profObjects))"
          :index="calcIndex(form)"
        />
      </el-dialog>

      <el-dialog
        width="440px"
        :show-close="false"
        title="Отчет по технике"
        :visible.sync="techModal"
      >
        <AddJobsWorkProf
          type="TECH"
          :report="form"
          @close="techModal = false"
          :isEditable="isEditable"
          :user="user"
          ref="addJobsWork"
          :mainForm="form"
          :approve="form.approve"
          v-if="isLoad && techModal"
          :options_works="options_works"
          @update="updateObjectsTech"
          :inputObjects="form.techObjects"
          :index="calcIndex(form)"
        />
      </el-dialog>


      <el-dialog
        title="Копировать отчет"
        :visible.sync="copyData.dialogVisible"
        width="300px"
        v-loading="copyData.loading"
      >
        <div style="display: flex; flex: 1; margin-left: 20px; margin-bottom: 4px">
          <strong>Дата нового отчета</strong>
        </div>
        <el-date-picker
          :picker-options="pickerOptions"
          v-model="copyData.pickData"
          type="date"
          :editable="false"
          :clearable="false"
          placeholder="Выбрать дату">
        </el-date-picker>
        <span slot="footer" class="center" style="display: flex; justify-content: center">
        <el-button @click="copyData.dialogVisible = false">Отмена</el-button>
        <el-button type="primary" @click="doCopy">Копировать</el-button>
      </span>
      </el-dialog>
    </div>


    <el-dialog width="300px" :visible.sync="dialogObjectTime" title="Смена" custom-class="turn-modal">
      <el-form>
        <el-form-item label="Часы">
          <el-input class="input" v-model="timeProfGlobal.value"></el-input>

        </el-form-item>
      </el-form>

      <span slot="footer" class="center" style="display: flex; justify-content: center">
        <el-button @click="dialogObjectTime = false;  timeProfGlobal.value = tmpTime">Отмена</el-button>
        <el-button type="primary" @click="() => updateObjects(form.inputObjects)">Сохранить</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AddObjects from '../Reports/components/AddObjects';
import UploadFile from '@/views/Dashboard/Reports/components/UploadFile';
import firebase from 'firebase';
import dayjs from 'dayjs';
import Multiselect from 'vue-multiselect';
import FilterSelect from '../../../components/FilterSelect';
import AddCategory from "./components/AddCategory";
import AddUser from "./components/AddUser";
import {getRole, getUsersOptions} from "../../../firestore/users";
import VueTribute from 'vue-tribute'
import Comments from "./Comments";
import AddJobsWork from "./components/AddJobsWork";
import AddObjectJobsWork from "./components/AddObjectJobsWork";
import {calculatePercentage, formatNumber, pStatus, toFloat} from "../../../utils/numberUtils";
import _, {uniq} from "lodash";
import {getPermission, getPermissionByUser, isApprove} from "../../../firestore/permission";
import {apiUrl} from "../../../plugins/firebase";
import {getCurrentMonth} from "../../../utils/date";
import AddProfTechToJob from "./components/AddProfTechToJob";
import AddJobsWorkProf from "./components/AddJobsWorkProf";
import {filterJobs, filterObjects} from "../../../utils/filterJobs";
import {getChildList, mergeTmpDisabledByUsername} from "../../../utils/getChild";
import {v4 as uuidv4} from "uuid";
import Vue from "vue";
import AddJobsTabel from "./components/AddJobsTabel.vue";

export default {
  name: 'Create',
  components: {
    AddJobsTabel,
    AddJobsWorkProf,
    AddProfTechToJob,
    AddObjectJobsWork,
    AddJobsWork,
    Comments, AddUser, AddCategory, FilterSelect, UploadFile, AddObjects, Multiselect, VueTribute
  },
  data() {
    return {
      dirs: [],
      totalPlanProfsConfig: [],
      objResult: [],
      jobResult: [],
      apiUrl,
      tmpTime: 10,
      isLoad: false,
      isSelect: false,
      dialogObjectTime: false,
      searchable: {
        line: false,
      },
      comment: {
        text: '',
        files: [],
      },
      worksModal: false,
      workTypeOptions: [],
      updated: true,
      newAuthor: null,
      fileList: [],
      usersOptions: [],
      tributeOptions: {
        trigger: '@',
        noMatchTemplate: () => '<li>Пользователь не найден</li>',
        values: (text, cb) => this.getNames(text, cb)
      },
      loader: false,
      isInit: false,
      dialogObject: false,
      isApprove: false,
      previewSrc: null,
      loading: true,
      copyData: {
        pickData: dayjs().format(),
        dialogVisible: false,
        loading: false
      },
      isCreatedUser: false,
      currentId: null,
      user: {},
      current_line: {},
      allUsers: [],
      options_works: [],
      permission: null,
      permissionUser: null,
      form_saved: null,
      techModal: false,
      role: 'admin',
      shifts: [
        {
          label: 'Смена 1',
          value: 1,
        }, {
          label: 'Смена 2',
          value: 2,
        }, {
          label: 'Смена 3',
          value: 3,
        }
      ],
      form: {
        totalProfNorm: 0,
        totalProfFact: 0,
        totalProfPlan: 0,
        totalProfValue: 0,
        totalProfPlanNorm: 0,

        totalPercent: 0,
        totalProfPercent: 0,
        profObjects: [
          {
            id: null,
            index: 0,
            name: "",
            parentId: null,
            jobs: [{
              jobs: [],
              work_type: null,
              work_type_dir: null
            }],
          }
        ],
        techObjects: [
          {
            id: null,
            index: 0,
            name: "",
            parentId: null,
            jobs: [{
              jobs: [],
              work_type: null,
              work_type_dir: null
            }],
          }
        ],

        inputObjects: [],
        notifications: [],
        approve: false,
        reportTECH: null,
        reportPROF: null,
        fot: {
          plan: 0,
          fact: 0
        },
        TECH: {
          workers: '',
          workers_plan: ''
        },
        PROF: {
          workers: '',
          itr: '',
          workers_plan: '',
          itr_plan: ''
        },
        jobs_internal: [],
        work_type: [],
        work_type_dir: [],
        daily_plan: {
          workers: '',
          itr: '',
        },

        joints: [{
          id_joint: null,
          welder: null,
          materials: null,
          leader: null,
          axe_elevation: null,
        }],
        leader: null,
        place: null,
        line: null,
        datetime: dayjs().format(),
        dateunix: dayjs(dayjs().format('YYYY-MM-DD') + 'T00:00:00+00:00').utc().unix(),
        comment: '',
        object: '',
        group: [],
        jobs: {},
        index: 1,
        user: {},
        isEditable: true,
        files: [],
        turn: {
          value: 1,
          label: 'Смена 1',
        },
      },
    };
  },

  async mounted() {
    const users = await getUsersOptions(this.$store.state.project.id, true)

    this.currentId = this.$route.params.id
    setTimeout(async () => {
      this.isApprove = await isApprove(this.$store.state.project.id)
      this.init()
    }, 0);


    this.role = await getRole(this.$store.state.project.id);
    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || firebase.auth().currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id), undefined, true);

    this.usersOptions = users.filter((u) => u._data.isCompany)

    this.allUsers = users.filter((u) => !u._data.isCompany)

    const dirs = await firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('dirs')
      .get()

    dirs.forEach((d) => {
      this.dirs.push({id: d.id, ...d.data()})
    })


    if (!this.$store.state.project.version) {
      this.permissionUser = await getPermissionByUser(this.$store.state.project.id, firebase.auth().currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id) || null);
    }


    if (!this.$route.params.id && (this.$store.state.project.plan && this.$store.state.project.plan.id) && this.$store.state.project.reportOne && this.$store.state.project.reportOne.autoPlan) {
      const jobsResponse = await this.fire()
        .collection('jobs')
        .where('type', '==', 'JOB')
        .get()

      console.log('get jobs 1')


      const objResponse = await this.fire()
        .collection('objects')
        .get()

      objResponse.forEach((subDoc) => {
        const data = subDoc.data();

        this.objResult.push({
          id: subDoc.id,
          name: data.name,
          objects: data.objects,
          code: data.code,
          index: data.index,
          parentId: data.parentId || undefined,
          isParent: data.isParent,
        });
      });

      this.objResult = _.orderBy(filterObjects(filterObjects(getChildList(this.objResult), this.permission), this.permissionUser), 'index', ['asc']);


      jobsResponse.forEach((subData) => {
        this.jobResult.push({...subData.data(), originalId: subData.id})
      });

      this.autoPlanHandler()
    }
  },
  watch: {
    '$route.params': {
      handler() {
        this.init();
      },
      deep: true,
    },
    'form.user': {
      handler(prev, next) {
        if ((!prev || !next) || prev.label !== next.label) {
          this.calcUserTime();
          this.calcProfsPlan(prev);
        }
      },
      deep: true,
    },
    // 'form.totalPercent'() {
    //   if (this.$route.params.id) {
    //     firebase.firestore()
    //       .collection('projects')
    //       .doc(this.$store.state.project.id)
    //       .collection('workorders')
    //       .doc(this.currentId)
    //       .update({
    //         totalPercent: this.form.totalPercent
    //       })
    //   }
    // }
  },

  computed: {
    totalProfPercent() {
      if((this.form.totalProfNorm  || this.form.totalProfFact)) {
        let result =   Number(Number(Number( this.form.totalProfNorm || 0) / Number(this.form.totalProfFact.time || this.form.totalProfFact || 0)) * 100).toFixed()

        if(result > 999999999999 || isNaN(result)) {
          return  0
        }

        return result
      }



      if(this.form.totalProfPercent === Infinity || isNaN(this.form.totalProfPercent)) {
        return  0
      }

      return Number(this.form.totalProfPercent)
    },
    pickerOptions() {
      if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
        let month = getCurrentMonth(this.$store.state.project.plan.name);
        if (String(month).length === 1) {
          month = '0' + month
        }

        const year = this.$store.state.project.plan.name.split('-')[1]
        const unixDateEnd = dayjs(year + '-' + month + '-' + '31' + ' 00:00:00').unix() * 1000

        const unixDateStart = dayjs(year + '-' + month + '-' + '01' + ' 00:00:00').unix() * 1000

        return {
          disabledDate(time) {
            return time.getTime() > unixDateEnd || time.getTime() < unixDateStart;
          },
        }
      } else {
        return {}
      }
    },
    techs() {
      let info = {
        time: 0,
        itr_time: 0
      }
      const result = []

      this.form.inputObjects.forEach((e) => {
        e.jobs.forEach((r) => {
          if (!r) {
            return
          }


          let TECH = r.TECH;


          if (TECH && TECH.jobs) {
            TECH.jobs.forEach((job) => {
              if (!result[job.name]) {
                result[job.name] = {
                  value: Number(job.value),
                  time: Number(job.time) * Number(job.value),
                  name: job.name
                }
              } else {
                result[job.name] = {
                  value: Number(result[job.name].value + Number(job.value)),
                  time: Number(result[job.name].time) + Number(job.time) * Number(job.value),
                  name: job.name
                }
              }

              info.time += Number(job.time) * Number(job.value)

            })
          }
        })
      })


      this.form.techObjects.forEach((e) => {
        e.jobs.forEach(({jobs}) => {
          if (jobs) {
            jobs.forEach((job) => {

              if (!result[job.name]) {
                result[job.name] = {
                  value: Number(job.value),
                  time: Number(job.time) * Number(job.value),
                  name: job.name
                }
              } else {
                result[job.name] = {
                  value: Number(result[job.name].value + Number(job.value)),
                  time: Number(result[job.name].time) + Number(job.time) * Number(job.value),
                  name: job.name
                }
              }

              info.time += Number(job.time) * Number(job.value)

            })
          }
        })
      })


      const finalArray = Object.values(result)


      finalArray.push({
        value: this.techPlanFact.fact,
        strong: true,
        time: info.time,
        name: 'Итого'
      })

      return finalArray

    },
    isShowFot() {
      return !!(this.form.user.fot || (this.form.user._data && this.form.user._data.fot) || null);
    },
    calcFot() {
      const prof = this.profs.find(({sum}) => sum)
      const _data = this.form.user.fot || (this.form.user._data && this.form.user._data.fot) || null;

      if (_data) {
        // console.log(this.user, 'UUUSSSERR')
        let plan = 0
        for (let obj of this.form.inputObjects) {

          for (let j of obj.jobs) {


            if (j.job && j.job.unit_fot && this.$store.state.project.is_fot) {
              plan += (Number(j.value || 0) * Number(j.job.unit_fot || 0))
            } else if (j.job && j.job.price_unit) {
              plan += (Number(j.value || 0) * Number(j.job.price_unit || 0))
            }
          }
        }

        let fact = parseFloat(Number(Number(prof.time) * Number(_data)).toFixed(2));

        if  ((this.form.user._data && this.form.user._data.is_one_report_table) || this.form.user.is_one_report_table) {
          let result = 0
          this.form.profObjects.forEach((e) => {
            e.jobs.forEach(({jobs}) => {
              if (jobs) {
                jobs.forEach((job) => {
                  if(Number(job.hourRate)) {
                    result += Number(job.hourRate * job.time)
                  }
                })
              }
            })
          })

          fact = result

        }


        return {
          plan: parseFloat(Number(plan).toFixed(2)),
          fact: fact
        }
      } else {
        return {
          plan: 0,
          fact: 0,
        }
      }

      // console.log(this.user, 'UUUSSSERR')
      // return {
      //   fact: this.form.fot.fact,
      //   plan: this.form.fot.plan,
      //   time: prof.time
      // }
    },
    profs() {
      const result = {}

      let info = {
        time: 0,
        itr_time: 0
      }

      this.form.inputObjects.forEach((e) => {
        e.jobs.forEach((r) => {
          if (!r) {
            return
          }
          let PROF = r.PROF;

          if (PROF && PROF.jobs) {
            PROF.jobs.forEach((job) => {
              if (!result[job.name]) {
                result[job.name] = {
                  value: Number(job.value || 0),
                  time: Number(job.time || 0) * Number(job.value || 0),
                  name: job.name
                }
              } else {
                result[job.name] = {
                  value: Number(result[job.name].value || 0) + Number(job.value || 0),
                  time: Number(result[job.name].time || 0) + Number(job.time || 0) * Number(job.value || 0),
                  name: job.name
                }
              }

              if (job.kind && job.kind.value === 'itr') {
                info.itr_time += Number(job.time || 0) * Number(job.value || 0)
              } else {
                info.time += Number(job.time || 0) * Number(job.value || 0)
              }
            })
          }
        })
      })


      const nicknames_labels = []
      this.form.profObjects.forEach((e) => {
        e.jobs.forEach(({jobs}) => {
          if (jobs) {
            jobs.forEach((job) => {
              if (!result[job.name]) {
                if ((this.form.user._data && this.form.user._data.is_one_report_table) || this.form.user.is_one_report_table) {
                  nicknames_labels.push(job.label)
                }
                result[job.name] = {
                  value: Number(job.value || 0),
                  time: Number(job.time || 0) * Number(job.value || 0),
                  name: job.name
                }
              } else {
                if  ((this.form.user._data && this.form.user._data.is_one_report_table) || this.form.user.is_one_report_table) {
                  if (nicknames_labels.includes(job.label)) {
                    result[job.name] = {
                      value: Number(result[job.name].value || 0),
                      time: Number(result[job.name].time || 0) + Number(job.time || 0) * Number(job.value || 0),
                      name: job.name
                    }
                  } else {
                    result[job.name] = {
                      value: Number(result[job.name].value || 0) + Number(job.value || 0),
                      time: Number(result[job.name].time || 0) + Number(job.time || 0) * Number(job.value || 0),
                      name: job.name
                    }
                    nicknames_labels.push(job.label)
                  }
                } else {
                  result[job.name] = {
                    value: Number(result[job.name].value || 0) + Number(job.value || 0),
                    time: Number(result[job.name].time || 0) + Number(job.time || 0) * Number(job.value || 0),
                    name: job.name
                  }
                }

              }
              if (job.kind && job.kind.value === 'itr') {
                info.itr_time += Number(job.time || 0) * Number(job.value || 0)
              } else {
                info.time += Number(job.time || 0) * Number(job.value || 0)
              }
            })
          }
        })
      })


      const finalArray = Object.values(result).filter(({time, value}) => time || value)


      finalArray.push({
        value: parseFloat(Number(this.profPlanFact.fact || 0).toFixed(1)),
        strong: true,
        sum: true,
        time: parseFloat(Number(info.time || 0).toFixed(1)),
        norm: parseFloat(Number(this.profPlanFact.time).toFixed(1)),

        name: 'Итого рабочие'
      })

      this.form.fact = parseFloat(Number(info.time || 0).toFixed(1))

      finalArray.push({
        value: parseFloat(Number(this.profPlanFact.itr || 0).toFixed(1)),
        strong: true,
        time: parseFloat(Number(info.itr_time).toFixed(1)),
        name: 'Итого ИТР'
      })

      return finalArray

    },
    profPlanFact() {
      let result = {
        plan: 0,
        fact: 0,
        percent: 0,
        itr: 0,
        itr_plan: 0,
        itr_time: 0,
        time: 0,
      }


      this.form.inputObjects.forEach((e) => {
        e.jobs.forEach((r) => {
          if (!r) {
            return
          }
          let PROF = r.PROF;

          if (PROF && PROF.jobs) {
            PROF.jobs.forEach((job) => {

              if (job.kind && job.kind.value === 'itr') {
                result.itr = result.itr + Number(job.value)
                result.itr_plan = result.itr_plan + Number(job.plan || 0)
                result.itr_time = result.itr_time + Number(job.time || 0)

              } else {
                result.fact = result.fact + Number(job.value || 0)
                result.plan = result.plan + Number(job.plan || 0)
                result.time = result.time + Number(job.time || 0)

              }
            })
          }
        })
      })


      const nicknames = []

      this.form.profObjects.forEach((e) => {
        e.jobs.forEach(({jobs}) => {
          if (jobs) {
            jobs.forEach((job) => {
              if  ((this.form.user._data && this.form.user._data.is_one_report_table) || this.form.user.is_one_report_table) {
                if (nicknames.includes(job.label)) {
                  if (job.kind && job.kind.value === 'itr') {
                    result.itr_plan = result.itr_plan + Number(job.plan || 0)
                    result.itr_time = result.itr_time + Number(job.time || 0)
                  } else {
                    result.plan = result.plan + Number(job.plan || 0)
                    result.time = result.time + Number(job.time || 0)

                  }
                } else {
                  if (job.kind && job.kind.value === 'itr') {
                    result.itr = result.itr + Number(job.value)
                    result.itr_plan = result.itr_plan + Number(job.plan || 0)
                    result.itr_time = result.itr_time + Number(job.time || 0)
                  } else {
                    result.fact = result.fact + Number(job.value || 0)
                    result.plan = result.plan + Number(job.plan || 0)
                    result.time = result.time + Number(job.time || 0)

                  }
                }
                nicknames.push(job.label)

              } else {
                if (job.kind && job.kind.value === 'itr') {
                  result.itr = result.itr + Number(job.value)
                  result.itr_plan = result.itr_plan + Number(job.plan || 0)
                  result.itr_time = result.itr_time + Number(job.time || 0)
                } else {
                  result.fact = result.fact + Number(job.value || 0)
                  result.plan = result.plan + Number(job.plan || 0)
                  result.time = result.time + Number(job.time || 0)

                }
              }
            })
          }
        })
      })


      return result
    },
    techPlanFact() {
      let result = {
        plan: 0,
        fact: 0,
        percent: 0,
        time: 0,
        itr: 0,
        itr_plan: 0
      }


      this.form.inputObjects.forEach((e) => {
        e.jobs.forEach((r) => {
          if (!r) {
            return
          }
          let TECH = r.TECH;
          if (TECH && TECH.jobs) {
            TECH.jobs.forEach((job) => {
              result.fact = result.fact + Number(job.value || 0)
              result.time = result.time + Number(job.time || 0)
              result.plan = result.plan + Number(job.plan || 0)
            })
          }
        })
      })


      this.form.techObjects.forEach((e) => {
        e.jobs.forEach(({jobs}) => {
          if (jobs) {
            jobs.forEach((job) => {
              result.time = result.time + Number(job.time || 0)
              result.fact = result.fact + Number(job.value || 0)
              result.plan = result.plan + Number(job.plan || 0)
            })
          }
        })
      })


      return result
    },
    isExecutor() {
      const reporter = this.form.executor || {}
      const uid = firebase.auth().currentUser.uid;

      if (this.role === 'editor') {
        return this.isEditable || this.isStatus || reporter.uid === uid || reporter.id === uid
      }

      return reporter.uid === uid || reporter.id === uid
    },
    link() {
      return window.location.href;
    },
    isEditable() {
      if (this.user && this.user.usePermission && this.user.role === 'admin') {
        return false
      }

      if ((this.form.user && this.form.user.uid) === firebase.auth().currentUser.uid) {
        return true
      }

      return this.role === 'admin' || !this.$route.params.id;
    },
    isNotification() {
      const notifications = (this.form.notifications || []).map(({value}) => value)

      return !this.isEditable && !this.isExecutor && notifications.includes(firebase.auth().currentUser.uid)
    },
    isStatus() {
      if (this.user && this.user.usePermission) {
        return false
      }


      if (!this.isEditable || this.isNotification) {
        return this.user.company === this.form.executor.name
      }

      return true
    },
    status_options() {
      const result = [
        {
          label: 'В работе',
          value: 'IN_PROGRESS',
        },
        {
          label: 'Выполнено',
          value: 'IN_TEST',
        }
      ]

      if (this.isEditable) {
        result.push({
          label: 'Завершено',
          value: 'DONE',
        })
      }

      return result;
    }
  },
  provide() {
    this.timeProfGlobal = Vue.observable({value: 10});
    return {
      timeProfGlobal: this.timeProfGlobal
    };
  },
  methods: {
    clearPopulation() {
      this.form.totalProfPlan = ''
    },
    async calcProfsPlan(user) {
      if (((user._data && user._data.id) || user.id) && !(this.$store.state.project.plan && this.$store.state.project.plan.id)) {
        console.log()
        const result = await firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id).collection('company_plan')
          .doc((user._data && user._data.id) || user.id).get()

        const listWorks = result.data()
        this.totalPlanProfsConfig = (listWorks && listWorks.listWorks) || []

        this.calcTotalProfPlan()
      } else {
        this.totalPlanProfsConfig = []
      }
    },
    calcTotalProfPlan() {
      if (this.totalPlanProfsConfig.length) {
        let result = 0
        this.totalPlanProfsConfig.forEach((d) => {
          if (!(d._data && d._data.kind && d._data.kind.value === 'itr')) {
            const datetime = dayjs(this.form.datetime).format('DD.MM.YYYY');

            if (d.volumes && d.volumes[this.form.turn.value - 1] && d.volumes[this.form.turn.value - 1] [datetime]) {
              result += Number(d.volumes[this.form.turn.value - 1][datetime])
            }
          }
        })
        this.form.totalProfPlan = parseFloat(Number(result).toFixed(0))
      } else {
        this.form.totalProfPlan = 0
        this.form.totalProfValue = 0
      }
    },
    calcAuto() {


      this.form.inputObjects.forEach((obj, index) => {
        this.form.inputObjects[index].jobs.forEach((job, i) => {
          // this.form.inputObjects[index].jobs[indexJob].daily_plan = toFloat(job.job.allPlan) - toFloat(job.job.totalValue)
          const objects = this.form.inputObjects;
          if (!this.form.inputObjects[index].jobs[i].value) {
            this.$store.state.project.daily_plan ? (objects[index].jobs[i].daily_plan ? this.form.inputObjects[index].jobs[i].value = objects[index].jobs[i].daily_plan : this.form.inputObjects[index].jobs[i].daily_plan = parseFloat((objects[index].jobs[i].job.allPlan - objects[index].jobs[i].job.totalValue)).toFixed(4)) : this.form.inputObjects[index].jobs[i].value = parseFloat(((objects[index].jobs[i].job.allPlan || 0) - (objects[index].jobs[i].job.totalValue || 0)).toFixed(4))


            if (this.form.inputObjects[index].jobs[i].daily_plan < 0) {
              this.form.inputObjects[index].jobs[i].daily_plan = ''
            }

            if (this.form.inputObjects[index].jobs[i].value < 0) {
              this.form.inputObjects[index].jobs[i].value = ''
            }
          }
        })
      })

    },
    autoPlanHandler() {
      this.isInit = true
      const datetime = dayjs(this.form.datetime).format('DD.MM.YYYY');


      const objResult = JSON.parse(JSON.stringify(this.objResult))
      objResult.forEach((obj, index) => {
        const jobs = (this.jobResult.filter((j) => j.objects.includes(obj && obj.id || 'all')))
          .filter((job) => {
            try {
              return !!job.volumes[this.form.turn.value - 1][datetime]
            } catch (e) {
              return false
            }
          })


        if (!obj.jobs) {
          obj.jobs = []
        }


        ///

        objResult[index].jobs = jobs.map((job) => {
          return {
            PROF: {},
            TECH: {},
            daily_plan: job.volumes[this.form.turn.value - 1][datetime],
            datetime: this.form.datetime,
            allPlan: job.plan,
            job: {
              ...job,
              allPlan: job.plan,
              daily_plan: job.volumes[this.form.turn.value - 1][datetime]
            },
            turn: this.form.turn,
            uid: uuidv4(),
            user: null,
            value: ''
          }
        })
      })

      this.form.inputObjects = [...objResult].filter(({jobs}) => jobs && jobs.length)


      this.form = {...this.form}

      setTimeout(() => {
        this.isInit = false
      }, 400)
    },
    async changeDate() {
      this.isInit = true
      for (let obj in this.form.inputObjects) {
        for (let jbs in this.form.inputObjects[obj].jobs) {
          const jobsResponse = await this.fire()
            .collection('jobs')
            .doc(this.form.inputObjects[obj].jobs[jbs].job.id).get()

          const jobNewData = jobsResponse.data()

          if (jobNewData) {
            delete jobNewData.inputs
            this.form.inputObjects[obj].jobs[jbs].job = {
              ...this.form.inputObjects[obj].jobs[jbs].job,
              ...jobNewData,
              allPlan: jobNewData.plan
            }
            try {

              const datetime = dayjs(this.form.datetime).format('DD.MM.YYYY');

              this.form.inputObjects[obj].jobs[jbs].daily_plan = jobNewData.volumes[this.form.turn.value - 1][datetime] || 0;


            } catch (e) {
            }

          }
        }
      }

      this.calcTotalProfPlan()

      this.isInit = false

      this.form = {...this.form}
    },
    getProfColor(form) {

      if (this.totalProfPercent) {
        return this.totalProfPercent <= 100 ? '#D32F2F' : '#7CB342'
      }

      if (form.totalProfNorm === 0 && form.totalProfFact === 0) {
        return '#7CB342'
      } else if (form.totalProfNorm && !form.totalProfFact) {
        return '#7CB342'
      } else if (form.totalProfFact && !form.totalProfNorm) {
        return '#D32F2F'
      } else {
        return this.totalProfPercent <= 100 ? '#D32F2F' : '#7CB342'
      }
    },
    async getOptionalWork() {
      let req = null;
      const result = [];
      req = firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('works_type')
        .where('type', 'in', ['job', 'JOB']);


      await req.get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              label: data.name,
              value: data.unit,
              id: data.id || subDoc.id,
              dir: data.dir || null,
              _data: data
            });
          });
        })
        .finally(() => {
          this.options_works = [
            {
              label: 'Не выбрано',
              value: null,
            },
            ...result,
          ];
        });
    },
    async doCopy() {
      this.$router.push(`/dashboard/one-reports/create/${this.$route.params.id}/copy?date=${dayjs(this.copyData.pickData).format('YYYY-MM-DD')}`)

      this.copyData.dialogVisible = false

      setTimeout(() => {
        this.calcTotalProfPlan()
      }, 1000)
    },
    approve() {
      if(!this.isApprove) {
        return false
      }
      this.form.approve = !this.form.approve;

      if (this.$route.params.id) {
        const db = firebase.firestore();
        const projId = this.$store.state.project.id;
        const reportId = this.$route.params.id;

        const approveUser = this.form.approve
          ? {name: this.user.name, uid: firebase.auth().currentUser.uid}
          : null;

        const payload = {
          approve: this.form.approve,
          approveUser,
        };

        const reportRef = db
          .collection('projects').doc(projId)
          .collection('reports').doc(reportId);

        const fastRef = db
          .collection('projects').doc(projId)
          .collection('reports_fast').doc(reportId);

        const batch = db.batch();

        // основной документ
        batch.update(reportRef, JSON.parse(JSON.stringify(payload)));

        // fast-документ: обновляем только нужные поля
        batch.set(
          fastRef,
          {
            ...payload,
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          },
          {merge: true}
        );

        batch.commit().catch(() => {
          // опционально: вернуть флаг назад/показать уведомление
        });
      }
    },
    addAuthor(user) {
      this.newAuthor = user;
    },
    calcUserTime(flag) {
      setTimeout(() => {
        const users = this.usersOptions;

        if (this.form.user && this.form.user.value && !this.form.user._data) {
          const user = users.find(({label}) => label === this.form.user.label)
          if (user._data.hours) {
            this.timeProfGlobal.value = user._data.hours || 10
          } else {
            this.timeProfGlobal.value = 10

          }

        } else if (this.form.user && this.form.user._data && this.form.user._data.hours) {
          this.timeProfGlobal.value = this.form.user._data.hours || 10

        } else {
          this.timeProfGlobal.value = 10
        }
      }, flag ? 0 : 1000)
    },
    calcIndex(form) {
      let i = 0

      try {
        this.form.inputObjects.forEach(({jobs}) => {

          if (jobs.length) {
            jobs.forEach((job) => {
              if (job.reports) {
                i += job.reports.length
              }
            })
          }
        })
      } catch (e) {
      }

      return this.form.index + i
    },
    pStatus,
    calculatePercentage,
    formatNumber,
    updateObjectsProf(objects) {

      this.form.profObjects = JSON.parse(JSON.stringify([...objects]))
      this.form = {...this.form}
      this.form_saved = JSON.parse(JSON.stringify({...this.form}))


      this.form = {...this.form}

      setTimeout(() => {
        const fact = this.profs.find(({sum}) => sum)

        if (fact && fact.time) {
          this.form.totalProfFact = fact.time;
          this.form.totalProfValue = fact.value;

          if (this.$store.state.project.is_fot) {
            this.form.totalProfPercent = Number(Number(Number(this.calcFot.plan || 0) / Number(this.calcFot.fact || 0)) * 100).toFixed()
          } else {
            this.form.totalProfPercent = Number(Number(Number(this.form.totalProfNorm || 0) / Number(fact.time || 0)) * 100).toFixed()
          }
        }

        this.form.totalProfFact = fact;
        this.form = {...this.form}
      }, 500)
    },
    updateObjectsTech(objects) {
      this.form.techObjects = [...objects]
      this.form = {...this.form}
      this.form_saved = JSON.parse(JSON.stringify({...this.form}))


      this.form = {...this.form}
    },
    updateObjects(objects) {
      this.dialogObjectTime = false
      this.form.inputObjects = [...objects]


      this.form.profObjects = this.form.profObjects
        .map(obj => {
          // оставляем только те jobs, где tmpDisable !== true
          let filteredJobs = (obj.jobs || []).filter(job => !job.tmpDisable);
          const result = []
          filteredJobs.forEach((o) => {
            o.jobs = (o.jobs || []).filter(job => !job.tmpDisable);

            if(o.jobs.length) {
              result.push(o)
            }
          })
          return {
            ...obj,
            jobs: result
          };
        })
        // удаляем объекты, у которых jobs после фильтрации пустой
        .filter(obj => obj.jobs.length > 0);

      if ((this.form.user._data && this.form.user._data.is_one_report_table) || this.form.user.is_one_report_table ) {
        this.form.inputObjects.forEach(({jobs}) => {
          jobs.forEach((job1) => {
            if(job1.table && job1.table[0] ) {
              // job1.table[0].jobs = job1.table[0].jobs.map((d) => {
              //   d.tmpDisable = true
              //   return {...d, tmpDisable: true, jobs: d.jobs.map((s) => ({...s, tmpDisable: true}))}
              // })

              const index = this.form.profObjects.findIndex((d) => !d.id)


              if (index === -1) {
                this.form.profObjects.push({
                  id: null,
                  index: 0,
                  jobs: [],
                  name: "",
                  parentId: null,
                  tmpDisable: true
                })

                if (!this.form.profObjects[0].jobs.length) {
                  console.log('STEP 1', this.form.profObjects)
                  this.form.profObjects[0].jobs[0] = {
                    jobs: [],
                    work_type: null,
                    work_type_dir: null
                  }
                }

                this.form.profObjects[0].jobs[0].jobs = [...job1.table[0].jobs[0].jobs.map((r) => {
                  r.tmpDisable = true
                  return r
                })]
              } else {
                this.form.profObjects[index].tmpDisable = true
                if(!this.form.profObjects[index].jobs.length) {

                  this.form.profObjects[index].jobs.push({
                    jobs: [],
                    work_type: null,
                    work_type_dir: null
                  })
                }

                if(!this.form.profObjects[index].jobs.length) {
                  this.form.profObjects[index].jobs[0].jobs = job1.table[0].jobs[0].jobs.map((r) => {
                    r.tmpDisable = true
                    return r
                  })

                } else {

                  this.form.profObjects[index].jobs[0].jobs = [...this.form.profObjects[index].jobs[0].jobs, ...job1.table[0].jobs[0].jobs.map((r) => {
                    r.tmpDisable = true
                    return r
                  })]



                  this.form.profObjects[index].jobs[0].jobs = mergeTmpDisabledByUsername(this.form.profObjects[index].jobs[0].jobs);

                }
              }
            }
          })
        })

        console.log( this.form.profObjects, ' this.form.profObjects 2')

        // this.form.profObjects
      }

      if (!this.form.profObjects.length) {
        this.form.profObjects.push({
          id: null,
          index: 0,
          name: "",
          parentId: null,
          jobs: [{
            jobs: [],
            work_type: null,
            work_type_dir: null
          }],
        })

        console.log(this.form.profObjects, 'this.form.profObjects this.form.profObjects this.form.profObjects')
      }

      this.form = {...this.form}
      this.form_saved = JSON.parse(JSON.stringify({...this.form}))

      let total = {
        plan: 0,
        fact: 0
      }

      let totalProfTmp = {
        norm: 0,
        fact: 0,
        plan: 0
      }

      let fot = {
        price: 0,
        plan: 0
      }


      for (let obj of this.form.inputObjects) {

        for (let j of obj.jobs) {
          const work_type = this.options_works.find(({id}) => id === j.job.work_type)

          if (work_type && work_type._data && work_type._data.unit_for_value !== undefined) {
            totalProfTmp.norm += Number(toFloat(work_type._data.unit_for_value || 0)) * Number(toFloat(j.value));
            totalProfTmp.fact += j.PROF.time;
            totalProfTmp.plan += Number(toFloat(work_type._data.unit_for_value || 0)) * Number(toFloat(j.daily_plan));

          }

          total.plan += Number(toFloat(j.daily_plan || 0))
          total.fact += Number(toFloat(j.value || j.job.value || 0))
        }

      }

      this.form.fot.plan = fot.plan
      this.form.totalProfNorm = totalProfTmp.norm;

      if (!this.totalPlanProfsConfig.length) {
        this.form.totalProfPlan = Number(totalProfTmp.plan / this.timeProfGlobal.value).toFixed(0);
      }

      this.form.totalProfPlanNorm = totalProfTmp.plan
      this.form.totalPercent = Number(calculatePercentage(total.fact, total.plan)).toFixed()
      const fact = this.profs.find(({sum}) => sum)

      if (fact && fact.time) {
        this.form.totalProfFact = fact.time;
        this.form.totalProfValue = fact.value;

        if (this.$store.state.project.is_fot) {
          this.form.totalProfPercent = Number(Number(Number(this.calcFot.plan || 0) / Number(this.calcFot.fact || 0)) * 100).toFixed()
        } else {
          this.form.totalProfPercent = Number(Number(Number(totalProfTmp.norm || 0) / Number(fact.time || 0)) * 100).toFixed()

        }
      } else {
        this.form.totalProfPercent = 0
        this.form.totalProfValue = 0
        this.form.totalProfFact = 0
      }

      if (isNaN(this.form.totalProfPercent)) {
        this.form.totalProfPercent = 0
      }
      this.form = {...this.form}
    },
    getNames(t, sb) {
      const users = this.allUsers;

      const result = []
      const user = this.form.user || {}
      const reporter = this.form.executor || {}

      users.forEach(({label, value}) => {
        if (this.form.notifications.find((u) => u.value === value) || user.uid === value || reporter.uid === value || firebase.auth().currentUser.uid === value) {
          result.push({
            value: label,
            key: label
          })
        }
      })

      sb([
        {key: 'Все', value: 'Все'},
        ...result
      ])
    },
    async back() {
      await this.$router.push(`/dashboard/one-reports`)
    },
    onCopy() {
      this.$notify.success({
        offset: 60,
        title: 'Ссылка скопирована',
      });
    },
    async addObject(n) {
      this.form.object = n;
    },
    setStatus(status) {
      if (status.value === 'DONE' || status.value === 'IN_TEST') {
        if (!this.form.finish_dateunix || isNaN(this.form.finish_dateunix)) {
          this.form.finish_datetime = dayjs().format();
          this.form.finish_dateunix = dayjs(dayjs().format()).utc().unix()
        }
      }
    },
    addCategory(n) {
      this.form.category = n;
    },
    addUser(n) {
      this.form.executor = n;
    },
    fire() {
      if (this.$route.query.version) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.query.version)
      }

      if (this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id)) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id))
      }

      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    async init() {
      this.fetchUser();
      if (this.$route.params.id) {
        await this.fetchData();
        this.isLoad = true

        if (this.$route.name === 'onereportsCopy') {
          this.isInit = true

          this.fetchIndex();
          this.form.datetime = dayjs(this.$route.query.date, 'YYYY-MM-DD').format()


          for (let obj in this.form.inputObjects) {
            for (let jbs in this.form.inputObjects[obj].jobs) {
              const jobsResponse = await this.fire()
                .collection('jobs')
                .doc(this.form.inputObjects[obj].jobs[jbs].job.id).get()
              console.log('get jobs 3')
              const jobNewData = jobsResponse.data()

              if (jobNewData) {
                delete jobNewData.inputs
                this.form.inputObjects[obj].jobs[jbs].job = {
                  ...this.form.inputObjects[obj].jobs[jbs].job,
                  ...jobNewData,
                  allPlan: jobNewData.plan
                }

                try {

                  const datetime = dayjs(this.form.datetime).format('DD.MM.YYYY');

                  this.form.inputObjects[obj].jobs[jbs].daily_plan = jobNewData.volumes[this.form.turn.value - 1][datetime] || 0;
                } catch (e) {
                }

              }
            }
          }

          this.isInit = false

        }

        this.form = {...this.form}

      } else {
        this.fetchIndex();
        this.isLoad = true

        if (this.$store.state.project.plan) {
          let month = getCurrentMonth(this.$store.state.project.plan.name);
          if (String(month).length === 1) {
            month = '0' + month
          }

          const year = this.$store.state.project.plan.name.split('-')[1]
          const unixDateStart = dayjs(year + '-' + month + '-' + '01' + ' ' + '00:00:00').unix()

          const unixDateEnd = dayjs(year + month + dayjs(unixDateStart * 1000).daysInMonth() + ' 00:00:00').unix()

          if (!dayjs().isBetween(dayjs(unixDateStart * 1000).format(), dayjs(unixDateEnd * 1000).format(), null, '[]')) {
            if (unixDateEnd > dayjs().unix()) {
              this.form.dateunix = dayjs(dayjs(unixDateStart * 1000).format('YYYY-MM-DD') + 'T00:00:00+00:00').utc().unix()
              this.form.datetime = dayjs(unixDateStart * 1000).format()
            }

            if (unixDateStart < dayjs().unix()) {
              this.form.dateunix = dayjs(dayjs(unixDateEnd * 1000).format('YYYY-MM-DD') + 'T00:00:00+00:00').utc().unix()
              this.form.datetime = dayjs(unixDateEnd * 1000).format()
            }
          }
        }
      }

      await this.getOptionalWork();
    },
    sendReport() {
      this.$prompt('Пожалуйста введите email', 'Отправка отчета', {
        confirmButtonText: 'Отправить',
        inputValue: firebase.auth().currentUser.email,
        cancelButtonText: 'Закрыть',
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: 'Некорректный емайл',
      }).then(({value}) => {
        this.loading = true;
        const proxy = firebase.functions().httpsCallable('onMailReports');
        proxy(
          {
            projectId: this.$store.state.project.id,
            reportId: this.$route.params.id,
            email: value,
          },
        ).then(() => {
          this.$notify({
            offset: 60,

            title: 'Успешно!',
            message: 'Отчет отправлен на почту',
            type: 'success',
          });
        }).catch(() => {
          this.$notify({
            offset: 60,

            title: 'Ошибка',
            message: 'Произошла ошибка, попробуйте позже',
            type: 'error',
          });
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    deleteReport() {
      this.$confirm('Вы действительно хотите удалить этот отчет?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      })
        .then(async () => {
          const db = firebase.firestore();
          const projId = this.$store.state.project.id;
          const reportId = this.$route.params.id;

          const reportRef = db.collection('projects').doc(projId).collection('reports').doc(reportId);
          const fastRef = db.collection('projects').doc(projId).collection('reports_fast').doc(reportId);

          const batch = db.batch();
          // удаляем оба документа атомарно
          batch.delete(fastRef);
          batch.delete(reportRef);

          try {
            await batch.commit();

            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'Отчет удален',
              type: 'success',
            });

            setTimeout(() => {
              this.$router.push('/dashboard/one-reports');
            }, 1000);
          } catch (e) {
            this.$notify({
              offset: 60,
              title: 'Ошибка',
              message: 'Не удалось удалить отчет. Попробуйте еще раз.',
              type: 'error',
            });
          }
        })
        .catch(() => {
          // пользователь нажал "Нет" — ничего не делаем
        });
    },
    fetchUser() {
      this.loading = true;
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .where('uid', '==', this.$store.state.company.uid || firebase.auth().currentUser.uid)
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const user = subDoc.data();
            if (user.name.length && user.position && user.position.length) {
              this.isCreatedUser = subDoc.id;
            }
            this.user = {
              ...user,
              name: user.name || firebase.auth().currentUser.email,
              user_profile_id: subDoc.id,
            };


            if (!this.currentId) {
              this.form.user = this.usersOptions.find(({label}) => label === this.user.company)

              if (!this.form.user) {
                this.form.user = {
                  label: this.user.company,
                  company: this.user.company,
                  value: 'custom'
                }
              }
            }

          });

        }).finally(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    preview(file) {
      window.open(file, '_blank');
    },
    addFile(f) {
      this.form.files.push(f);
    },
    addFileComment(f) {
      this.comment.files.push(f);
    },
    deleteTmpImg(i) {
      const comment = {...this.comment};
      comment.files.splice(i, 1);
      this.comment = comment;
    },
    deleteImg(id) {
      this.$confirm('Вы действительно хотите удалить этот файл?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        const images = [...this.form.files];
        images.splice(id, 1);
        this.form.files = images;
      });
    },
    fetchData() {
      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .doc(this.$route.params.id)
        .get().then((data) => {
          const subData = data.data();
          this.fileList = this.form.files.map((f, i) => {
            return {
              url: f,
              name: 'file__' + i,
            };
          });

          if (this.$route.name !== 'onereportsCopy') {
            this.form = {
              ...this.form,
              ...this.comment,
              ...subData,
            };
          } else {
            const report = JSON.stringify({
              ...this.form,
              ...this.comment,
              ...subData,
              datetime: this.$route.params.date
            }).replace(/"reportId":"[^"]*"/g, '"reportId":null');
            this.form = JSON.parse(report);
          }

        });
    },
    fetchIndex() {
      return new Promise((resolve, reject) => {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports')
          .orderBy('index', 'desc').limit(1)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((data) => {
              this.form.index = Number(data.data().index) + 1;
            });
            resolve();
          });
      });
    },
    async save() {
      if (this.loader) return false;
      this.loader = true;

      // ── helpers для fast-документа
      const safe = (obj, path, d = undefined) => {
        try {
          return path.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj) ?? d;
        } catch (_) {
          return d;
        }
      };
      const compact = (o) => Object.fromEntries(Object.entries(o || {}).filter(([, v]) => v !== undefined));
      const buildFast = (data) => {
        // вычисляем planId, если нет
        let planId = data.planId || safe(data, 'jobs.0.job.planID') || safe(data, 'jobs.0.0.job.planID') || null;

        // человекочитаемая дата
        let date_display = null;
        try {
          const dt = data.datetime || null;
          if (typeof dt === 'string') {
            const base = dt.includes('+') ? dt.split('+')[0] : dt;
            date_display = dayjs(base).isValid() ? dayjs(base).format('DD/MM/YY') : null;
          }
        } catch (_) {
        }

        return compact({
          type: data.type, // 'ONE_REPORT'
          index: data.index,
          dateunix: data.dateunix,
          datetime: data.datetime,
          internalIndex: data.internalIndex,

          approve: !!data.approve,
          approveUser: compact({
            name: safe(data, 'approveUser.name'),
            uid: safe(data, 'approveUser.uid'),
          }),

          userId: data.userId || safe(data, 'user.uid') || null,
          reporterId: safe(data, 'reporter.uid') || null,

          user: compact({
            uid: safe(data, 'user.uid'),
            name: safe(data, 'user.name'),
            company: safe(data, 'user.company'),
          }),
          reporter: compact({
            uid: safe(data, 'reporter.uid'),
            name: safe(data, 'reporter.name'),
            company: safe(data, 'reporter.company'),
          }),
          company: data.company ?? null,

          object: compact({
            id: safe(data, 'object.id'),
            name: safe(data, 'object.name'),
          }),
          inputObjects: Array.isArray(data.inputObjects)
            ? data.inputObjects.map(o => compact({id: safe(o, 'id')})).filter(o => o.id)
            : [],

          planId,

          totalPercent: data.totalPercent ?? null,
          totalProfPercent: data.totalProfPercent ?? null,
          totalProfPlan: data.totalProfPlan ?? null,
          totalProfValue: data.totalProfValue ?? null,
          totalProfNorm: data.totalProfNorm ?? null,
          totalProfFact: data.totalProfFact ?? null,

          fot: compact({
            plan: safe(data, 'fot.plan'),
            fact: safe(data, 'fot.fact'),
          }),

          date_display,
          hasJobs: Array.isArray(data.jobs) && data.jobs.length > 0,

          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        });
      };

      if (!this.form.datetime) {
        this.$notify({
          offset: 60,
          title: 'Заполните все поля!',
          message: 'Пожалуйста заполните поле c датой',
          type: 'error',
        });
        return;
      }

      const user = firebase.auth().currentUser;

      this.updateObjects(this.form.inputObjects);
      this.form.fot = this.calcFot;

      // ── СОЗДАНИЕ
      if (!this.$route.params.id || this.$route.name === 'onereportsCopy') {
        await this.fetchIndex();

        user.providerData.forEach(() => {
          let userId = this.$store.state.company.uid || this.user.user_profile_id || this.user.uid;
          let userObj = this.user;

          if (this.form.user && this.form.user.value) {
            userId = this.form.user.value;
            if (this.form.user._data) {
              userObj = {

                ...this.form.user._data,
                user_profile_id: userId,
                uid: userId,
                value: this.form.user.value,
                label: this.form.user.label,
              };
            } else {
              userObj = this.form.user;
            }
          }

          const payload = JSON.parse(JSON.stringify({
            ...this.form,
            planId: (this.$store.state.project.plan && this.$store.state.project.plan.id) || null,
            userId: userId,
            datetime: dayjs(this.form.datetime).format(),
            dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
            deadline_datetime: this.form.deadline_datetime ? dayjs(this.form.deadline_datetime).format() : null,
            deadline_dateunix: dayjs(dayjs(this.form.deadline_datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
            deadline_datetime_end: this.form.deadline_datetime_end ? dayjs(this.form.deadline_datetime_end).format() : null,
            deadline_dateunix_end: dayjs(dayjs(this.form.deadline_datetime_end).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
            finish_datetime: dayjs(this.form.finish_datetime).format(),
            finish_dateunix: dayjs(dayjs(this.form.finish_datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
            user: userObj,
            totalProfPercent: this.totalProfPercent,
            reporter: this.user,
            type: 'ONE_REPORT',
          }));

          const projId = this.$store.state.project.id;

          firebase.firestore()
            .collection('projects').doc(projId)
            .collection('reports')
            .add(payload)
            .then(async (docRef) => {
              // fast-версия на основании payload
              console.log(payload, 'PAYLOAD')
              const fast = buildFast(payload);
              console.log(fast, 'FAST')
              await firebase.firestore()
                .collection('projects').doc(projId)
                .collection('reports_fast').doc(docRef.id)
                .set(fast, {merge: true});

              this.$notify({offset: 60, title: 'Успешно!', message: 'Отчет добавлен', type: 'success'});
              setTimeout(() => {
                this.fetchIndex();
                this.$router.push('/dashboard/one-reports/');
              }, 1000);
            })
            .finally(() => {
              this.loader = true;
            })
            .catch(() => {
              this.$notify({offset: 60, title: 'Упс... ', message: 'Произошла ошибка повторите позже', type: 'error'});
            });
        });

        // ── РЕДАКТИРОВАНИЕ
      } else {
        const formData = JSON.parse(JSON.stringify({...this.form}));
        delete formData.user;
        delete formData.userId;
        delete formData.index;

        if (this.role === 'admin') {
          let userId = this.$store.state.company.uid || this.user.uid;
          let userObj = this.user;

          if (this.form.user && this.form.user.value) {
            userId = this.form.user.value;
            userObj = formData.user;
          }

          formData.user = userObj;
          formData.userId = userId;
          formData.reporter = this.user;
        }

        formData.user = this.form.user;
        if (formData.user && formData.user._data && formData.user.label) {
          formData.user = {
            label: formData.user.label,
            value: formData.user.value,
            ...formData.user._data,
          };
        }

        const updatePayload = JSON.parse(JSON.stringify({
          ...formData,
          totalProfPercent: this.totalProfPercent,
          planId: (this.$store.state.project.plan && this.$store.state.project.plan.id) || null,
          datetime: dayjs(this.form.datetime).format(),
          dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
          deadline_datetime: this.form.deadline_datetime ? dayjs(this.form.deadline_datetime).format() : null,
          deadline_dateunix: dayjs(dayjs(this.form.deadline_datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
          deadline_datetime_end: this.form.deadline_datetime_end ? dayjs(this.form.deadline_datetime_end).format() : null,
          deadline_dateunix_end: dayjs(dayjs(this.form.deadline_datetime_end).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
          finish_datetime: this.form.finish_datetime ? dayjs(this.form.finish_datetime).format() : null,
          finish_dateunix: this.form.finish_datetime ? dayjs(dayjs(this.form.finish_datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix() : null,
          type: 'ONE_REPORT',
        }));

        const projId = this.$store.state.project.id;
        const reportId = this.$route.params.id;

        firebase.firestore()
          .collection('projects').doc(projId)
          .collection('reports').doc(reportId)
          .update(updatePayload)
          .then(async () => {
            // читаем обновлённый документ, чтобы fast 100% соответствовал БД
            const snap = await firebase.firestore()
              .collection('projects').doc(projId)
              .collection('reports').doc(reportId)
              .get();

            const latest = snap.data() || updatePayload; // fallback: то, что отправили
            const fast = buildFast(latest);
            console.log(fast, 'FAST')

            await firebase.firestore()
              .collection('projects').doc(projId)
              .collection('reports_fast').doc(reportId)
              .set(fast, {merge: true});

            this.$router.push('/dashboard/one-reports');
            this.$notify({offset: 60, title: 'Успешно!', message: 'Отчет отредактирован', type: 'success'});
          })
          .finally(() => {
            this.loader = true;
          })
          .catch(() => {
            this.$notify({offset: 60, title: 'Упс... ', message: 'Произошла ошибка повторите позже', type: 'error'});
          });
      }
    }
  },
};
</script>
<style lang="scss">
.tribute-container {
  background: #fff;
  z-index: 999;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 0;

  ul {
    list-style-type: none;
    padding-inline-start: 0px;
    margin-block-start: 0px;
    margin-block-end: 0px;

    li {
      padding: 8px 16px;
      box-sizing: border-box;
      cursor: pointer;

      &:hover {
        background: #409EFF;
        color: #fff;
      }
    }
  }
}
</style>
<style scoped lang="scss">
.doc-search {
  position: relative;
  width: 20px;
  cursor: pointer;
  left: 86px;
  bottom: -34px;
}

.navigate-btn {
  margin-top: 20px;
  display: block;
}

.reports-create, .alert-report {
  margin: 0 auto;
  max-width: 382px;
  padding-top: 20px;
  width: calc(100% - 40px);
  overflow: hidden;
  padding-bottom: 100px;

  .add-jobs {
    display: flex;
    flex-direction: column;
  }

  .date-create {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  h4 {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin: 0;

    small {
      font-size: 10px;
      font-weight: 400;
    }
  }
}

.add-btn {
  width: 100%;

  &.isSelect {
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    align-items: center;
    margin-bottom: 2px;
    margin-top: 6px;
  }

  > > > .add {
    width: 100%;
  }

  margin-top: 6px;

  &.add-jobs {
    margin-top: 0;
  }
}

.select-job {
  margin-top: 20px;

  > > > .el-select {
    width: 100%;
  }
}

.report-li {
  span {
    max-width: 50%;
  }
}

.report-value {
  strong {
    font-weight: bold;
  }
}

.mobile-header-create {
  display: flex;
  padding-right: 16px;
  color: #fff;
  background: #3676cb;
  position: fixed;
  top: 0;
  //padding-top: 30px; // IOS ONLY
  right: 0;

  .progress-circle {
    margin-left: 8px;
  }

  .dot-auto {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    margin-right: 4px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  height: 50px;
  left: 120px;
  z-index: 9;
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: space-between;
}

@media screen and (max-width: 500px) {
  .report-value {
    width: 100%;
    justify-content: space-between !important;
  }

  .report-li {
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;


    .el-icon-close {
      margin-bottom: 12px;
    }

    .col-vo, .time {
      display: flex;
      flex-direction: row;

      > > > .el-form-item__label {
        margin-right: 6px !important;
      }
    }

    .time {
      margin-left: 10px;
    }

    span {
      max-width: 100%;
      font-weight: bold;
    }
  }
}

.report-li-title {
  font-size: 14px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0px;
}

.report-add-job {
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  padding: 20px 0;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;

  .report-ul {
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-bottom: 22px;
  }

  .jobs-li {
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &:last-child {
      border-bottom: none;
    }

    padding-bottom: 12px;
  }

  .report-li {
    display: flex;
    margin-top: 3px;
    justify-content: space-between;
    min-height: 58px;
    padding: 12px 0px;
    text-align: left;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;


    &.with-check {
      border-bottom: none;
      padding-bottom: 0px;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.report-file {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}


.create-footer {
  display: flex;
  justify-content: center;
  //padding-bottom: 34px; // IOS ONLY
  padding-bottom: 7px;

  position: fixed;
  border-top: 1px solid #ddd;
  align-items: center;
  padding-top: 10px;
  max-width: 382px;
  width: calc(100% - 40px);
  bottom: 0;
  background: #fff;
  z-index: 3;

  .el-form-item {
    margin-bottom: 8px !important;
  }
}

.report-ul {
  width: 100%;
}

> > > .el-form-item, > > > .el-form-item__content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .el-form-item__label {
    padding: 0 !important;
  }
}

.docs {
  > > > .el-form-item__content {
    align-items: flex-start;
  }
}

> > > .el-form-item {
  margin-bottom: 4px !important;
}

> > > .el-form-item__label {
  height: 32px !important;
}

.report-value {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  strong {
    opacity: 0.8;
    font-weight: bold;
  }

  > > > .el-input__inner {
    width: 92px;
    text-align: right;
    margin-right: 8px;
  }


}

.job-inputs {
  display: flex;
  align-items: center;
  width: 100% !important;

  margin-right: 4px;

  i {
    padding-left: 4px;
    cursor: pointer;
  }
}

.preview-images {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  flex: 1;
  margin-top: 16px;
  margin-bottom: 16px;

  .preview-img {
    width: 92px;
    height: 92px;
    margin: 6px;
  }

  .controls {
    display: flex;
    justify-content: space-between;
    background-color: rgba(0, 0, 0, 0.3);
    width: 92px;
    height: 92px;
    border-radius: 6px;
    margin-top: -98px;
    z-index: 2;
    position: relative;
    align-items: center;

    i {
      font-size: 24px;
      color: #fff;
      margin: 0 12px;
      cursor: pointer;
    }
  }

  img {
    width: 92px;
    height: 92px;
    border-radius: 6px;
    cursor: pointer;
    z-index: 1;
    position: relative;
  }
}

.add-block {
  display: flex;
  justify-content: flex-end;
}

.line-data {
  padding: 5px 15px;
  margin-bottom: 10px;
  background: #fff;
  background: #f7f7f7;
  box-shadow: 0px 0px 8px 0px #ccc;
  border-radius: 5px;
}

.pipe-close {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;
  margin-bottom: -42px;
  margin-top: 10px;
  font-size: 20px;
  cursor: pointer;

  i {
    margin-bottom: 10px;
  }

  > > > .add-btn-joint {
    z-index: 2;
    position: relative;
  }
}

.reports-edit-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: center;

  .i-container {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    padding: 6px;
    cursor: pointer;
    border: 1px solid #eee;
    color: #000;
    text-decoration: none;
    flex-direction: column;

    i {
      height: 24px;
    }

    span {
      font-size: 10px;
      margin-top: 6px;
    }

    &:hover {
      background: #eee;
    }
  }
}

.reports-create {
  padding: 0 20px;
}

.add-job {
  margin-top: -30px;
}

.reports-create {
  padding-top: 40px;
  //padding-bottom: 160px; // IOS ONLY
  padding-bottom: 117px;
}

.report-add-job {
  .line-data {
    padding-top: 24px;
    margin-bottom: 20px;
  }

  .report-ul.mul {
    margin-bottom: 0;
  }

  .add-block {
    margin-top: 30px;
  }

  .report-li > > > .el-form-item__label {
    height: 32px;
  }

  .col-vo {
    > > > .el-input__inner {
      width: 68px !important;
      padding: 0 5px !important;
    }
  }

  .time {
    > > > .el-input__inner {
      width: 58px !important;
      padding: 0 8px 0 2px !important;
      margin-right: 0px;
    }
  }
}

.reports-mul {
  > > > .el-form-item__label {
    margin-top: 2px;
  }

  > > > .el-form-item {
    margin-bottom: 10px;
  }
}

.total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 14px;
}

.links-list {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 20px;
  align-items: center;

  a {
    color: #3676cb;
    font-size: 14px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  i {
    cursor: pointer;
    font-size: 20px;
    opacity: 0.8;
  }
}

.comments {
  display: flex;
  flex-direction: column;

  .comment {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    padding: 10px 0;
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .text {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}

.delete-btn {
  font-size: 12px;
  color: #ff4500;
  cursor: pointer;
}

.desc {
  text-align: left;
}

.progress-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  color: #13ce66;
  min-width: 32px;
  height: 32px;
  border-radius: 18px;
  padding-left: 2px;
  padding-right: 2px;
  border: 2px solid #13ce66;
}

.main-tech-inputs {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  strong {
    font-size: 14px;
    margin-top: 16px;
    margin-bottom: 3px;
  }
}

.tech-name {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  width: 100%;

  span {
    font-size: 13px;
    font-weight: bold;
  }
}

.disabled {
  div {
    opacity: 0.6;
    pointer-events: none !important;
  }
}
</style>
<style scoped lang="scss">
.disable-report {
  opacity: 0.6;
  pointer-events: none;
}

.el-icon-success {
  color: #2ecc71 !important;
  font-size: 28px !important;
  margin-left: 4px;
}

.fa-chevron-right {
  font-size: 20px;
  margin-left: 12px;
}
</style>
<style lang="scss">
.workorder-create {
  .el-form-item {
    margin-bottom: 2px !important;
  }


  .date-pick-workorder {
    .el-input--suffix .el-input__inner {
      padding-right: 0 !important;
    }

    input {
      font-size: 15px !important;
    }
  }
}


.desktop-header-left, .desktop-header-right {
  display: flex;
  align-items: center;
}

.desktop-header-selects {
  display: flex;
  align-items: center;

  .user-select {
    .el-form-item {
      min-width: 182px !important;
      max-width: 220px !important;

      width: 220px !important;
    }
  }

  .el-form-item {
    margin-bottom: 0;
    min-width: 158px;
    max-width: 158px;

    width: 158px;

    .multiselect__tags, .multiselect__single {
      color: #fff !important;
      background: #1e90ff;
    }

    .multiselect--disabled .multiselect__current, .multiselect--disabled .multiselect__select {
      color: #fff !important;
      background: #1e90ff;
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }

    .multiselect__select {
      border-left: 2px solid #fff;
    }

    .multiselect__select::before {
      color: #fff !important;
      border-color: #fff transparent transparent;
    }
  }
}

.desktop-show-create {
  display: none !important;
}

.desktop-header {
  position: sticky;
  top: 50px;
  z-index: 6;
  background: rgb(241, 241, 241);
}


@media screen and (min-width: 764px) {
  .create-one-report-jo {
    padding-bottom: 80px;


    .el-table .el-table__cell {
      padding: 4px 0;
    }


    .desktop-header {
      .multiselect__placeholder {
        color: #f1f1f1 !important;
      }

      .fix-bg {
        background: #409EFF;
        left: 4px;
        width: 62px;
        top: -2px;
        height: 52px;
        position: fixed;
        border-radius: 4px;
      }

      display: flex;
      justify-content: space-between;
      max-width: 1200px;
      width: 100%;
      flex: 1;
      align-items: center;
      margin: 0 auto;

      .desktop-header-right {

        input {
          background: rgba(0, 0, 0, 0) !important;
        }

        ::placeholder {
          color: #fff !important;
        }
      }
    }

    .prof-tech-desktop {
      margin-top: 32px;
      display: flex;
      box-sizing: border-box;

      align-items: flex-start;

      .line-title {
        display: flex;

        strong {
          font-size: 20px;
        }
      }


      .prof-desktop {
        display: flex;
        flex-direction: column;
        flex: 1;
        padding-right: 20px;
        box-sizing: border-box;
      }

      .tech-desktop {
        display: flex;
        padding-left: 20px;

        flex-direction: column;
        box-sizing: border-box;
        flex: 1;
      }
    }

    .report-file {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      box-sizing: border-box;
      padding-left: 20px;
      flex: 1;
      width: 100%;
    }

    .comment-textarea {
      .el-form-item__label {
        font-size: 17px;
      }

      width: 50%;

      .el-form-item {
        width: 100%;
      }

      .el-textarea__inner {
        height: 120px;
      }
    }

    .reports-create.workorder-create {
      background: #fff;
      border-radius: 4px;
      padding: 0 20px;
      padding-bottom: 24px;
      box-sizing: border-box;
    }

    .create-comment {
      display: flex;
      margin-top: 20px;

      .comment-textarea {
        display: flex;
        justify-content: flex-start;

        .el-form-item__label {
          display: flex;
          padding: 0;
          justify-content: flex-start;
        }
      }
    }

    .add-desktop-obj {
      display: flex;
      justify-content: flex-start;
      width: 100px;

      .desktop-show-create {
        font-size: 15px !important;
      }
    }

    .one-report-search {
      margin-bottom: 8px !important;
    }

    .fas.fa-chevron-right {
      font-size: 18px !important;
    }

    .one-report-search {
      display: flex;
    }

    .reports-create {
      max-width: 1200px !important;
      width: 100% !important;
    }

    .desktop-show-create {
      display: flex !important;
    }

    .mob-show-create {
      display: none !important;
    }

    .create-footer {
      max-width: 1200px !important;
      width: calc(100% - 40px) !important;
      padding: 8px 16px;
      margin-left: -20px;
      box-sizing: border-box;
    }

    .create-footer-container {
      justify-content: flex-end !important;
    }
  }

  .one-reports-create, .one-reports-update {
    display: none !important;
    padding: 0 20px;
    box-sizing: border-box;

    .bm-burger-button {
      .line-style {
        background-color: #000 !important;
      }
    }
  }


  .progress-circle-header-ro {
    margin-right: 12px;
  }


  .create-one-report-jo {
    display: flex;
    width: 100vw;
    justify-content: center;
    margin-top: -34px;
    padding-bottom: 40px;
    height: 100%;
    min-height: 100vh;
    background: #f1f1f1;
  }


}

.red {
  color: #cc3700;
}

.turn-modal {
  .el-dialog__body {
    padding-top: 0;
    padding-bottom: 20px;

    .el-form-item__label {
      font-size: 16px;
      line-height: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOne/Create.vue